/**
 * Reserved doc tags — plain tags with system meaning.
 *
 * Tags were chosen over the server's `visibility` field for doc-level
 * permission because every existing doc was created with the server default
 * `visibility: 'internal'` — keying "admin-only" off that would have hidden
 * the whole pre-existing library from user-tier members. A reserved tag
 * defaults to ABSENT (visible to everyone) and needs no data migration.
 *
 * NOTE: enforcement is client-side only for now — the /sops lambda returns
 * all docs to any workspace member. Server-side gating (like internalNotes
 * on sprints) is a known follow-up.
 */

/** Docs migrated from a mission's built-in notes (kept out of the library grid by default). */
export const MISSION_NOTES_TAG = 'mission-notes';

/** Doc-level permission: hidden from user-tier members everywhere. */
export const ADMIN_ONLY_TAG = 'admin-only';

export const isMissionNotesDoc = (doc) =>
  Array.isArray(doc?.tags) && doc.tags.includes(MISSION_NOTES_TAG);

export const isAdminOnlyDoc = (doc) =>
  Array.isArray(doc?.tags) && doc.tags.includes(ADMIN_ONLY_TAG);
